export default __webpack_public_path__ + "static/media/toolboxvid.1a4eb978.mp4";